import { ContextualField } from '../../../models';
import { PropertyType } from '../../../models/enum';

export const IsSingleDashboardFile: ContextualField = {
    extraData: {},
    icon: 'fa-object-group',
    label: 'Send dashboards as single file',
    modelName: 'isDashboardsSingleFile',
    placeholder: 'Send dashboards as single file',
    propertyName: 'isDashboardsSingleFileProperty',
    propertyType: PropertyType.Boolean,
    required: false,
};